import axios from "axios";
import React, { useContext, useState } from "react";
import MainNav from "../../components/Navbar/MainNav";
import { Context } from "../../context/Context";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../assets/css/WritePost.css';
import { AddPhotoAlternateRounded, FileCopyOutlined } from "@material-ui/icons";
import {axiosInstance} from '../../utils'


const WritePost = () => {
  const { user } = useContext(Context);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [categories, setCategories] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [photo, setPhoto]= useState('');
  const [success, setSuccess] = useState(false)


  //handle submit
  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    let newPost = {
      author: user.username,
      title,
      desc,
      categories,
      photo
    }
    if(file) {
        const data = new FormData();
        const filename = Date.now() + file.name;
        data.append('name', filename)
        data.append('file', file)
        newPost.photo = filename;
        try {
          await axiosInstance.post("/upload", data)
        }catch (err) {}
    }
    try {
      const res = await axiosInstance.post("/posts", newPost);
      setSuccess(true);
      setTimeout(()=> {
        window.location.reload();
      }, 2000)
    }
    catch(err) {}
  }


  return (
    <div>
    <MainNav/>
    {success && <div className="success">Post has been submitted successfully</div>}
    <Container className="custom_wrapper">
      <Row>
      <Col>
      <h1 className="add_post">Add a new post</h1>
      {file && (
        <img src={URL.createObjectURL(file)} alt="" />
      )}
      <div className="form_wrapper">
        <form onSubmit={handleSubmit}>
        <div className="input__wrap">
          <label htmlFor="blog_image">Add Blog image: <AddPhotoAlternateRounded /> </label>
          <input id="blog_image" type="file" 
          style={{"display": "none"}}
          onChange={e => setFile(e.target.files![0])}
          />
        </div>
        <div className="input__wrap">
          <input 
            type="text" 
            placeholder='Add blog title' 
            name="title"
            onChange={e => setTitle(e.target.value)}
          />
        </div>
        <div className="input__wrap">
          <textarea 
            rows={10}
            placeholder='Add blog content'
            name="desc"
            onChange={e => setDesc(e.target.value)}
          >
          </textarea>
        </div>
        <div className="input__wrap">
          <input 
            type="text" 
            placeholder="Type categories. seperate mutiple catgeories with coma," 
            name="categories"
            onChange={e => setCategories(e.target.value)}
          />
        </div>
        <button type="submit">send post</button>
        </form>
      </div>
      </Col>
      </Row>
      </Container>
    </div>
  )
}

export default WritePost
